// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/tabs.scss
// module id = 885
// module chunks = 0